import { AutenticationEventType } from './../../../../autentication/autentication.event.type';
import { EventTypes } from './../../../../shared/EventTypes';
import { AppEventDispatcher } from './../../../../utils/AppEventDispatcher';
import { Investment } from './../models/investment';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { InvestmentsService } from '../../investments.service';

@Component({
	selector: 'app-history-movement',
	templateUrl: './history-movement.component.html',
	styleUrls: ['./history-movement.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class HistoryMovementComponent implements OnInit, OnDestroy {

	constructor(private investmentsService: InvestmentsService) { }

	investments: Array<Investment> = [];

	ngOnInit() {

		AppEventDispatcher.listen(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT, () => {
			this.load();
		});

		this.load();

	}

	ngOnDestroy() {
		AppEventDispatcher.removeListener(AutenticationEventType.ACCOUNT.CHANGE_ACCOUNT);
	}

	load() {
		this.preload(true);

		this.investmentsService.getMyInvestments('2008-01-01', new Date()).subscribe( data => {
			this.investments = data;
			this.preload(false);
		}, error => {
			AppEventDispatcher.dispatch(EventTypes.MESSAGE.SNACK, { msg: error.error.Mensagem });
			this.preload(false);
		});
	}

	preload(active, delay = 0) {
		AppEventDispatcher.dispatch(EventTypes.PRELOAD, {element: '[data-component="investments-extract"] .content', show: active, delay: delay});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/investments/investments-extract/history-movement/history-movement.component.ts